import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { parseRinderpassScanProfil, RinderpassScan, RinderpassScanProfil } from '../../classes/rinderpass-scan';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { MessageService } from '../../../../services/message-service/message.service';
import { FormControl } from '@angular/forms';
import { Rinderpass } from '../../classes/rinderpass';
import { ConfirmDialogComponent } from '../../../dialogs/confirm-dialog/confirm-dialog.component';
import { PassportJobLiveService } from '../passport-job-live.service';

@Component({
    selector: 'kiene-fehlerhafte-seiten-dialog',
    templateUrl: './fehlerhafte-seiten-dialog.component.html',
    styleUrls: ['./fehlerhafte-seiten-dialog.component.scss'],
})
export class FehlerhafteSeitenDialogComponent implements OnInit, OnDestroy {
    fehlerhafteSeiten: Rinderpass[] = [];
    aktuelleSeite: Rinderpass;
    pdfAvailable = false;

    zifferCtrl = new FormControl();
    geschlechtCtrl = new FormControl();
    rasseCtrl = new FormControl();
    geburtsdatumCtrl = new FormControl();
    datumAusgabeCtrl = new FormControl();
    mutterCtrl = new FormControl();
    tierhalterNameCtrl = new FormControl();
    tierhalterStrasseCtrl = new FormControl();
    tierhalterPlzCtrl = new FormControl();
    tierhalterOrtCtrl = new FormControl();
    tierhalterVvvoCtrl = new FormControl();
    scanProfil: RinderpassScanProfil = 'ear_tag_only';
    allesKorrekt = false;
    isSaving = false;
    isLoading = false;

    pdfSource?: Uint8Array;
    currentPage = 1;
    rotation = 0;
    zoomFactor = 1;
    private sourcePdfBlob?: Blob;

    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly scan: RinderpassScan,
        public dialogRef: MatDialogRef<FehlerhafteSeitenDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly dialog: MatDialog,
        private readonly passportLive: PassportJobLiveService,
    ) {}

    ngOnInit(): void {
        this.scanProfil = parseRinderpassScanProfil(this.scan);
        this.ladeFehlerhafteSeitenFuerScan();
    }

    get isFullScan(): boolean {
        return this.scanProfil === 'full';
    }

    ngOnDestroy(): void {
        // no-op
    }

    public ladeSeite(seitenzahl: number) {
        this.aktuelleSeite = this.fehlerhafteSeiten[seitenzahl];
        const kurz = this.aktuelleSeite?.ohrmarke15 ? this.aktuelleSeite.ohrmarke15.slice(-10) : '';
        this.zifferCtrl.setValue(kurz, { emitEvent: false });
        if (this.isFullScan) {
            this.geschlechtCtrl.setValue(this.aktuelleSeite?.geschlecht ?? '', { emitEvent: false });
            this.rasseCtrl.setValue(this.aktuelleSeite?.rasse ?? '', { emitEvent: false });
            this.geburtsdatumCtrl.setValue(this.aktuelleSeite?.geburtsdatum ?? null, { emitEvent: false });
            this.datumAusgabeCtrl.setValue(this.aktuelleSeite?.datumAusgabe ?? null, { emitEvent: false });
            this.mutterCtrl.setValue(this.aktuelleSeite?.ohrmarke_mutter ?? this.aktuelleSeite?.ohrmarkeMutter ?? '', {
                emitEvent: false,
            });
            this.tierhalterNameCtrl.setValue(this.aktuelleSeite?.tierhalter_name ?? '', { emitEvent: false });
            this.tierhalterStrasseCtrl.setValue(this.aktuelleSeite?.tierhalter_strasse ?? '', { emitEvent: false });
            this.tierhalterPlzCtrl.setValue(this.aktuelleSeite?.tierhalter_plz ?? '', { emitEvent: false });
            this.tierhalterOrtCtrl.setValue(this.aktuelleSeite?.tierhalter_ort ?? '', { emitEvent: false });
            this.tierhalterVvvoCtrl.setValue(this.aktuelleSeite?.tierhalter_registriernr ?? '', { emitEvent: false });
        }
        const targetPage = Number(this.aktuelleSeite?.seitenzahl ?? 1);
        this.setPdfPage(targetPage);
    }

    private loadSourcePdf(): void {
        this.pdfAvailable = false;
        let scanParams = new HttpParams();
        scanParams = scanParams.set('grps_id', this.scan.grps_id);
        this.api.getBlob(this.apiBaseUrl + 'rinderpassscan/read_pdf.php', scanParams).subscribe({
            next: response => {
                if (!this.isValidPdfBlob(response)) {
                    this.loadSourcePdfFromNewService();
                    return;
                }
                this.setSourcePdfBlob(response);
                this.ladeErsteSeite();
            },
            error: fallbackError => {
                this.loadSourcePdfFromNewService(fallbackError);
            },
        });
    }

    private loadSourcePdfFromNewService(primaryError?: unknown): void {
        this.passportLive.getSourcePdfBlob(this.scan.grps_id).subscribe({
            next: response => {
                if (!this.isValidPdfBlob(response)) {
                    this.pdfAvailable = true;
                    this.messageService.errorMessage(
                        'Fehler',
                        primaryError instanceof HttpErrorResponse
                            ? primaryError
                            : new HttpErrorResponse({ error: primaryError ?? 'PDF konnte nicht geladen werden.' }),
                    );
                    return;
                }
                this.setSourcePdfBlob(response);
                this.ladeErsteSeite();
            },
            error: sourceError => {
                this.pdfAvailable = true;
                this.messageService.errorMessage(
                    'Fehler',
                    sourceError instanceof HttpErrorResponse
                        ? sourceError
                        : new HttpErrorResponse({ error: sourceError ?? primaryError }),
                );
            },
        });
    }

    private setSourcePdfBlob(blob: Blob): void {
        this.sourcePdfBlob = blob;
        new Response(blob).arrayBuffer().then(value => {
            this.pdfSource = new Uint8Array(value);
            this.pdfAvailable = true;
        });
    }

    private setPdfPage(pageNumber = 1): void {
        const safePage = Number.isFinite(pageNumber) && pageNumber > 0 ? Math.floor(pageNumber) : 1;
        this.currentPage = safePage;
    }

    rotateLeft(): void {
        this.rotation = (this.rotation + 270) % 360;
    }

    rotateRight(): void {
        this.rotation = (this.rotation + 90) % 360;
    }

    resetRotation(): void {
        this.rotation = 0;
    }

    zoomIn(): void {
        this.zoomFactor = Math.min(2.5, Number((this.zoomFactor + 0.1).toFixed(2)));
    }

    zoomOut(): void {
        this.zoomFactor = Math.max(0.5, Number((this.zoomFactor - 0.1).toFixed(2)));
    }

    resetZoom(): void {
        this.zoomFactor = 1;
    }

    get zoomPercent(): number {
        return Math.round(this.zoomFactor * 100);
    }

    private isValidPdfBlob(value: unknown): value is Blob {
        return value instanceof Blob && value.size > 0;
    }

    ohrmarkeNachtragen() {
        this.isSaving = true;
        const ohrmarke = '27600' + this.zifferCtrl.value;
        const endpoint = this.isFullScan ? 'rinderpass/correct_page.php' : 'rinderpass/update.php';
        const obj: Record<string, unknown> = { grp_id: this.aktuelleSeite.grp_id, ohrmarke15: ohrmarke };
        if (this.isFullScan) {
            obj.geschlecht = this.geschlechtCtrl.value;
            obj.rasse = this.rasseCtrl.value;
            obj.geburtsdatum = this.formatDateForApi(this.geburtsdatumCtrl.value);
            obj.datumAusgabe = this.formatDateForApi(this.datumAusgabeCtrl.value);
            obj.ohrmarkeMutter = this.mutterCtrl.value;
            obj.tierhalterName = this.tierhalterNameCtrl.value;
            obj.tierhalterStrasse = this.tierhalterStrasseCtrl.value;
            obj.tierhalterPlz = this.tierhalterPlzCtrl.value;
            obj.tierhalterOrt = this.tierhalterOrtCtrl.value;
            obj.tierhalterRegistriernr = this.tierhalterVvvoCtrl.value;
        }
        this.api.post(this.apiBaseUrl + endpoint, obj).subscribe({
            next: () => {
                this.messageService.infoMessage(
                    this.isFullScan ? 'Passdaten wurden gespeichert.' : 'Die Ohrmarke wurde erfolgreich nachgetragen',
                );
                this.ladeFehlerhafteSeitenFuerScan();
                this.isSaving = false;
            },
            error: err => {
                this.messageService.errorMessage('Fehler', err);
                this.isSaving = false;
            },
        });
    }

    private formatDateForApi(value: unknown): string | null {
        if (!value) return null;
        const d = value instanceof Date ? value : new Date(value as string);
        if (Number.isNaN(d.getTime())) return null;
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    private ladeFehlerhafteSeitenFuerScan() {
        this.isLoading = true;
        let params = new HttpParams();
        params = params.set('grps_id', this.scan.grps_id);
        params = params.set('erfolgreich', '0');
        params = params.set('pdf', '1');

        this.api.get(this.apiBaseUrl + 'rinderpass/read.php', params).subscribe({
            next: response => {
                this.fehlerhafteSeiten = response.records;
                if (this.fehlerhafteSeiten.length === 0) {
                    this.messageService.infoMessage('Es sind keine fehlerhaften Seiten mehr verfügbar!');
                    this.dialogRef.close(true);
                } else {
                    this.loadSourcePdf();
                }
                this.isLoading = false;
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.isLoading = false;
            },
        });
    }

    private ladeErsteSeite() {
        if (this.fehlerhafteSeiten?.length > 0) {
            this.ladeSeite(0);
        }
    }

    openDeleteSeite() {
        const input = new ConfirmDialogInput();
        input.headline = 'Seite löschen';
        input.text = `Soll die Seite ${this.aktuelleSeite.seitenzahl} wirklich gelöscht werden?`;
        input.okButton = 'Ja, Seite löschen';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.ok && result?.confirmed) {
                        this.deleteSeite();
                    }
                },
            });
    }

    deleteSeite(): void {
        this.isSaving = true;
        this.api.deleteGeneric(`${this.apiBaseUrl}rinderpass/delete.php`, this.aktuelleSeite).subscribe({
            next: () => {
                this.ladeFehlerhafteSeitenFuerScan();
                this.isSaving = false;
            },
            error: err => {
                this.messageService.errorMessage(`Fehler beim Löschen der Seite!`, err);
                this.isSaving = false;
            },
        });
    }
}
